import React from "react";
import "./SectionAbout.css";
import MainImg from "../../assets/About-cm.png";

export default function SectionAbout() {
  return (
    <section className="abt-wrapper">
      <div className="abt-container">

        {/* LEFT SIDE CONTENT */}
        <div className="abt-left">
          <span className="abt-tag">ABOUT BUSINESS</span>

          <h2 className="abt-title">
            Powering Tomorrow.<br />
            Comprehensive Solutions,<br />
            Driven by Extreme Service.
          </h2>

          <p className="abt-desc">
            CM Green Energy India Private Limited is a committed developer in the renewable energy sector, dedicated to providing comprehensive and high-level service in the transition to a sustainable future.
          </p>
        </div>

        {/* RIGHT SIDE IMAGES */}
        <div className="abt-right">
          <img src={MainImg} alt="Main Facility" className="abt-main-img" />
        </div>

      </div>
    </section>
  );
}
